export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref14618.27b27a4f.jpg";